import { Link } from "react-router-dom";
import { Calendar, MapPin, ArrowRight } from "lucide-react";

const months = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];
function formatDate(iso) {
  const d = new Date(iso + "T12:00:00");
  return { day: d.getDate(), month: months[d.getMonth()], year: d.getFullYear() };
}

export default function EventCard({ event }) {
  const d = formatDate(event.date);
  return (
    <Link
      to={`/eventos/${event.slug}`}
      data-testid={`event-card-${event.slug}`}
      className="card-rotta group flex flex-col md:flex-row overflow-hidden"
    >
      <div className="img-zoom relative md:w-2/5 aspect-[16/10] md:aspect-auto overflow-hidden">
        {event.cover_image && <img src={event.cover_image} alt={event.name} loading="lazy" className="w-full h-full object-cover" />}
        <div className="absolute top-4 left-4 bg-[#0B0B0B]/85 backdrop-blur border border-[#C6A762]/30 rounded-xl px-4 py-3 text-center min-w-[64px]">
          <div className="font-display text-2xl text-[#C6A762] leading-none">{d.day}</div>
          <div className="text-[10px] tracking-[0.25em] uppercase text-white/80 mt-1">{d.month}</div>
        </div>
      </div>
      <div className="md:w-3/5 p-6 md:p-8 flex flex-col">
        <div className="flex items-center gap-4 text-[11px] tracking-[0.2em] uppercase text-[#B8B8B8]">
          <span className="flex items-center gap-1"><MapPin size={12} className="text-[#C6A762]" /> {event.city}, {event.state}</span>
          <span className="flex items-center gap-1"><Calendar size={12} className="text-[#C6A762]" /> {d.day} {d.month} {d.year}</span>
        </div>
        <h3 className="font-display text-2xl md:text-3xl text-white mt-3 group-hover:text-[#C6A762] transition-colors">
          {event.name}
        </h3>
        <p className="text-sm text-[#B8B8B8] mt-3 leading-relaxed line-clamp-2">{event.short_description}</p>
        <div className="mt-auto pt-6">
          <span className="btn-ghost inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-xs group-hover:border-[#C6A762] group-hover:text-[#C6A762]">
            Saiba mais <ArrowRight size={13} />
          </span>
        </div>
      </div>
    </Link>
  );
}
